var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "check-out" },
    [
      _c("booking-header-details", {
        on: {
          edit: function ($event) {
            return _vm.$emit("edit-query", $event)
          },
        },
      }),
      _vm._v(" "),
      !_vm.isBookingEditMode
        ? _c(
            "div",
            {
              staticClass: "notification",
              attrs: { "data-component": "booking-notification" },
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c("span", { staticClass: "text" }, [
                    _vm._v(
                      _vm._s(
                        _vm.check.isMdAndDown
                          ? _vm.tc("booking.benefitsMobile")
                          : _vm.tc("booking.benefitsDesktop")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  !_vm.isFanClubBooking &&
                  _vm.showRoomUpgradeButton &&
                  !_vm.haveRoomUpgradeEnhancementSelected &&
                  !_vm.isBookingEditMode
                    ? _c("room-upgrade-modal", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var activate = ref.activate
                                return [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "room-upgrade-modal activator",
                                      class: {
                                        loading: _vm.roomUpgradeLoading,
                                        "upgrade-selected":
                                          _vm.roomUpgradeSelected,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.handleUpgradeRoomClick(
                                            $event,
                                            activate
                                          )
                                        },
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "space",
                                              32,
                                              $event.key,
                                              [" ", "Spacebar"]
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return activate($event)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.roomUpgradeSelected
                                              ? _vm.tc("booking.removeUpgrade")
                                              : _vm.tc(
                                                  "booking.upgradeAvailable"
                                                )
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2331538174
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "main-wrapper",
          attrs: { "data-component": "booking-checkout-wrapper" },
        },
        [
          _vm.isFanClubBooking
            ? _c("booking-check-out-fanclub", {
                attrs: {
                  "reasons-to-stay": _vm.reasonsToStay,
                  "user-titles": _vm.userTitles,
                  "order-confirmation-page": _vm.orderConfirmationPage,
                  "modify-detail-page": _vm.modifyDetailPage,
                },
                on: {
                  "show-cart": function ($event) {
                    return _vm.$emit("show-cart")
                  },
                },
              })
            : _c("booking-check-out", {
                attrs: {
                  "reasons-to-stay": _vm.reasonsToStay,
                  "user-titles": _vm.userTitles,
                  "order-confirmation-page": _vm.orderConfirmationPage,
                  "modify-detail-page": _vm.modifyDetailPage,
                },
                on: {
                  "show-cart": function ($event) {
                    return _vm.$emit("show-cart")
                  },
                },
              }),
          _vm._v(" "),
          _vm.check.isLgAndUp ? _c("cart-overview") : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }